import Vue from 'vue'
import App from './App.vue'
import router from './router'

import './../node_modules/bootstrap/scss/bootstrap.scss'
import './../node_modules/bootstrap/dist/js/bootstrap.min.js'
import '@/scss/global.scss'

window.$ = window.jQuery = require('jquery')

Vue.config.productionTip = false

import VueScrollTo from 'vue-scrollto'

Vue.use(VueScrollTo)

// You can also pass in the default options
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

new Vue({
  router,
  render: h => h(App),
  mounted: () => document.dispatchEvent(new Event('x-app-rendered'))
}).$mount('#app')
